import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '../../../components/Layout/Layout';
import api from '../../../api/axios';

export default function CustomerDetail() {
  const { id } = useParams();
  const [customer, setCustomer] = useState(null);
  const [allTrainings, setAllTrainings] = useState([]);
  const [selectedTraining, setSelectedTraining] = useState('');
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    Promise.all([
      api.get(`/customers/${id}`),
      api.get('/trainings'),
    ]).then(([c, t]) => {
      setCustomer(c.data);
      setAllTrainings(t.data);
    }).finally(() => setLoading(false));
  }, [id]);

  async function assignTraining() {
    if (!selectedTraining) return;
    try {
      await api.post(`/customers/${id}/trainings`, { trainingId: Number(selectedTraining) });
      const res = await api.get(`/customers/${id}`);
      setCustomer(res.data);
      setMsg('Schulung zugewiesen');
      setSelectedTraining('');
    } catch (err) {
      setMsg(err.response?.data?.message || 'Fehler');
    }
  }

  async function removeTraining(trainingId) {
    if (!window.confirm('Schulung entfernen?')) return;
    await api.delete(`/customers/${id}/trainings/${trainingId}`);
    const res = await api.get(`/customers/${id}`);
    setCustomer(res.data);
  }

  if (loading) return <Layout title="Kunde"><div>Laden...</div></Layout>;

  const assignedIds = new Set(customer.trainings.map(t => t.id));
  const available = allTrainings.filter(t => !assignedIds.has(t.id));

  return (
    <Layout title={customer.name}>
      <div style={{ marginBottom: '0.75rem' }}>
        <Link to="/admin/customers" className="btn btn-ghost btn-sm">← Zurück zur Liste</Link>
      </div>

      {msg && <div className="alert alert-info" style={{ marginBottom: '1rem' }}>{msg}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
        {/* Schulungen */}
        <div className="card">
          <h3 style={{ marginBottom: '1rem', fontSize: '1rem', fontWeight: 700 }}>Zugewiesene Schulungen</h3>
          {customer.trainings.length === 0 ? (
            <p style={{ color: 'var(--gray-dark)', fontSize: '0.9rem' }}>Noch keine Schulungen zugewiesen.</p>
          ) : (
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {customer.trainings.map(t => (
                <li key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.625rem 0.875rem', background: 'var(--light)', borderRadius: 8, gap: '0.5rem' }}>
                  <span style={{ fontWeight: 500 }}>
                    {t.title}
                    {t.ended_at && <span className="badge badge-failed" style={{ marginLeft: '0.5rem', fontSize: '0.7rem' }}>Beendet</span>}
                    {!t.ended_at && t.cancelled_at && <span className="badge badge-pending" style={{ marginLeft: '0.5rem', fontSize: '0.7rem' }}>Gekündigt zum {new Date(t.final_end).toLocaleDateString('de-DE')}</span>}
                  </span>
                  <button className="btn btn-danger btn-sm" onClick={() => removeTraining(t.id)}>Entfernen</button>
                </li>
              ))}
            </ul>
          )}
          {available.length > 0 && (
            <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
              <select value={selectedTraining} onChange={e => setSelectedTraining(e.target.value)} style={{ flex: 1, padding: '0.5rem', borderRadius: 8, border: '1px solid #e2e2e2', fontFamily: 'inherit' }}>
                <option value="">Schulung wählen...</option>
                {available.map(t => <option key={t.id} value={t.id}>{t.title}</option>)}
              </select>
              <button className="btn btn-primary btn-sm" onClick={assignTraining}>Zuweisen</button>
            </div>
          )}
        </div>

        {/* Benutzer */}
        <div className="card">
          <h3 style={{ marginBottom: '1rem', fontSize: '1rem', fontWeight: 700 }}>Benutzer</h3>
          <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            {customer.users.map(u => (
              <li key={u.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5rem 0.875rem', background: 'var(--light)', borderRadius: 8, opacity: u.ended_at ? 0.6 : 1 }}>
                <div>
                  <div style={{ fontWeight: 500, fontSize: '0.9rem' }}>{u.name}</div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--gray-dark)' }}>
                    {u.email}
                    {u.ended_at && ` · beendet am ${new Date(u.ended_at).toLocaleDateString('de-DE')}`}
                    {!u.ended_at && u.termination_at && ` · endet am ${new Date(u.termination_at).toLocaleDateString('de-DE')}`}
                  </div>
                </div>
                <span className={`badge ${u.role === 'customer_admin' ? 'badge-in_progress' : 'badge-pending'}`} style={{ alignSelf: 'center', fontSize: '0.7rem' }}>
                  {u.role === 'customer_admin' ? 'Admin' : 'Mitarbeiter'}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Layout>
  );
}
